const dispatch = require("~/store.js").dispatch;

const server = require("~/server.js");

const events = require("./auditSearchEvents.js");

const MetaAudit = require("~/types/MetaAudit.js");

const auditSearchDispatchers = {
    FindAudits(facility) {
        dispatch((thunkDispatch) => {
            const loading = events.Loading.New(facility);

            thunkDispatch(loading);
            
            const url = `audit?FacNumber=${facility.Number}`;

            server.Get(url)
                .then((response) => {
                    return response.json();
                })
                .then((json) => {
                    const data = json
                        .filter(MetaAudit.HasValidType)
                        .map(MetaAudit.FromServerData);

                    const withPlaceholders = MetaAudit.ListWithPeriodPlaceholders(
                        data, facility.PKID, facility.Number);
                    
                    const loaded = events.Loaded.New(withPlaceholders);
                    
                    thunkDispatch(loaded);
                })
                .catch((ex) => {
                    const errored = events.LoadErrored.New(ex);
                    
                    thunkDispatch(errored);
                });
        });
    }
};

module.exports = auditSearchDispatchers;


// WEBPACK FOOTER //
// ./src/events/auditSearch/auditSearchDispatchers.js